import React, { useEffect, useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Grid, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { updateIncentiveValue, updateIsValid } from '../../../stateManagement/actions/incentiveActions';
import dayjs, { Dayjs } from 'dayjs';
import { IncentiveHeader } from '../baseComponents/incentiveHeader/IncentiveHeader';
import { openPopup } from '../../../stateManagement/actions/popupActions';

export const ValidityDate = (props: { stateName: string }) => {

    // Use selector to get the stored dates from the redux state
    const storedDates = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]);
    const storedSummaryData =  useSelector((state: any) => state?.manageIncentive?.incentiveSummaryData.summaryList);
    const storedData = useSelector((state: any) => state?.manageIncentive?.data);
    const parseDate = (dateString: string): Date => {
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
      };
    let popupText = "";
   
    useEffect(() => {
        if (storedDates?.value) {
            const { startDate, endDate } = storedDates?.value ?? {};
            if(startDate && endDate){
                // if(isIncentiveAlreadyCreated(endDate)){
                //     openPopup("Alert" , "This incentive already exists");
                // }
                // else{
                    updateIsValid(true,props.stateName);
                //}
                
            }
            else{
                updateIsValid(false,props.stateName);
            }
        }
    }, [storedDates?.value]);

    const isIncentiveAlreadyCreated = (formattedEndDate: string) => {
        const startDate = storedData.storedDates?.value?.startDate;
        const users = storedData.user?.value.map((user: any) => user.name); // Extract users from storedData
    
        if (!startDate || !formattedEndDate || !users) return false;
    
        // Loop through each Map in the storedSummaryData array
        for (let map of storedSummaryData) {
            // Loop through the entries of the map to get the dateKey and associated kpiSelected
            for (const [key, kpiSelected] of map.entries()) {
                const [storedStartDate, storedEndDate, storedUser , duration , calculationType , incentiveId] = key.split("~");
                if(incentiveId == localStorage.editIncentiveID ){
                    continue;
                }
    
                // Check if the stored dates overlap with the current date range        
                if ((parseDate(startDate) >= parseDate(storedStartDate) && parseDate(startDate) <= parseDate(storedEndDate))  || (parseDate(formattedEndDate) >= parseDate(storedStartDate) && parseDate(formattedEndDate) <= parseDate(storedEndDate))) {
                    // If users overlap with the stored user, check KPIs
                    if (users.includes(storedUser)) {
                        if(storedData.period?.value != duration){
                            popupText = "Same incentive with different duration can't be created" ;
                            return true
                        }

                        if(storedData.calculationType?.value != calculationType){
                            popupText = "Same incentive with different Calculation Type can't be created" ;
                            return true
                        }
                        // Check if any KPI from storedData.kpi.value is already chosen
                        const kpiExists = storedData.kpi.value.some((kpi: any) =>
                            kpiSelected.includes(kpi.name)
                        );
    
                        if (kpiExists) {
                            popupText =  "You have previously established this incentive , please choose an alternative date range";
                            return true; // Incentive already exists
                        }
                    }
                }
            }
        }
    
        return false; // Incentive doesn't exist
    };
    
    // Handle the start date change
    const handleStartDateChange = (newDate: Dayjs | null) => {
        const formattedDate = newDate ? newDate.format('DD/MM/YYYY') : null;
        updateIncentiveValue({ startDate: formattedDate, endDate: null }, props.stateName);
    };

    // Handle the end date change
    const handleEndDateChange = (newDate: Dayjs | null) => {
        const { startDate, endDate } = storedDates?.value ?? {};
        const formattedEndDate = newDate ? newDate.format('DD/MM/YYYY') : null;
        if(isIncentiveAlreadyCreated(formattedEndDate ?? "")){
            openPopup("Alert" , popupText);
        }
        else{
             updateIncentiveValue({ startDate: startDate, endDate: formattedEndDate }, props.stateName);
        }
       
    };

    return (
        <div>
             <IncentiveHeader heading={storedDates?.label} open={true}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2}>
                {/* Start Date */}
                <Grid item xs={6}>
                    <DatePicker
                    inputFormat="DD/MM/YYYY"
                         minDate={dayjs().add(1, 'day') }
                        label="Start Date"
                        value={storedDates?.value?.startDate ? dayjs(storedDates?.value?.startDate, 'DD/MM/YYYY') : null}
                        onChange={handleStartDateChange}
                        renderInput={(params) => (
                            <TextField 
                                {...params} 
                                fullWidth 
                                inputProps={{ ...params.inputProps, readOnly: true }}
                              style={{backgroundColor :storedDates?.value?.startDate ? "#F0FBFF" : ""}}
                            />
                        )}
                    />
                </Grid>

                {/* End Date */}
                <Grid item xs={6}>
                    <DatePicker
                    disabled = {!storedDates?.value?.startDate}
                    inputFormat="DD/MM/YYYY"
                        label="End Date"
                        minDate={dayjs(storedDates?.value?.startDate, 'DD/MM/YYYY').add(1, 'day')}
                        value={storedDates?.value?.endDate ? dayjs(storedDates?.value?.endDate, 'DD/MM/YYYY') : null}
                        onChange={handleEndDateChange}
                        renderInput={(params) => (
                            <TextField 
                                {...params} 
                                fullWidth 
                                inputProps={{ ...params.inputProps, readOnly: true }} // Make the input read-only

                                style={{backgroundColor :storedDates?.value?.endDate ? "#F0FBFF" : ""}}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>
        </IncentiveHeader>
        </div>
       
    );
};
